<dt-modal-content size="small" (closeClick)="close()">
  <ng-template #title i18n>Registrieren</ng-template>
  <ng-template #content>
    <form #actualForm="ngForm" class="dt-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <mat-form-field>
        <mat-label i18n>E-Mail-Adresse</mat-label>
        <input type="email" matInput formControlName="email" required />

        @if (registerForm.hasError('alreadyExists', 'email')) {
          <mat-error i18n>Für die angegebene E-Mail-Adresse existiert bereits ein Account</mat-error>
        }
        @if (registerForm.hasError('required', 'email')) {
          <mat-error i18n>Bitte gib eine E-Mail-Adresse an</mat-error>
        }
        @if (registerForm.hasError('pattern', 'email')) {
          <mat-error i18n>Bitte gib Deine E-Mail-Adresse anstelle der TIM-Kennung ein</mat-error>
        }
        @if (registerForm.hasError('email', 'email')) {
          <mat-error i18n>Bitte gib eine gültige E-Mail-Adresse an</mat-error>
        }
      </mat-form-field>

      <dt-password-form></dt-password-form>

      <mat-form-field>
        <mat-label i18n>Benutzername (optional)</mat-label>
        <input matInput formControlName="username" />
      </mat-form-field>

      <mat-checkbox formControlName="privacy" i18n required
        >Ich willige in die Verarbeitung meiner personenbezogenen Daten entsprechend der
        <a href="https://entscheidungsnavi.de/privacy/" target="_blank">Datenschutzerklärung</a> ein.</mat-checkbox
      >

      @if (actualForm.submitted && registerForm.hasError('required', 'privacy')) {
        <mat-error i18n>Du musst die Datenschutzerklärung akzeptieren</mat-error>
      }

      @if (registerForm.hasError('serverError')) {
        <mat-error i18n>Bei der Übermittlung der Daten ist ein Fehler aufgetreten.</mat-error>
      }

      <button
        mat-raised-button
        [dtOverlayProgress]="registerForm.disabled"
        type="submit"
        color="accent"
        [disabled]="registerForm.disabled"
        i18n
        >Akzeptieren und registrieren</button
      >
    </form>
  </ng-template>
</dt-modal-content>
